import url from '../url'
import headers from '../headers'

export default {
	register (context, credentials) {
		return context.$http.post(
			`${url}/auth/register`,
			credentials
		)
	},
	registerWithInvitation (context, credentials) {
		return context.$http.post(
			`${url}/auth/registerwithinvitation`,
			credentials
		)
	},
	activate (context, hash) {
		return context.$http.post(
			`${url}/auth/activate`,
			hash
		)
	},
	login (context, credentials) {
		return context.$http.get(
			`${url}/auth/login`,
			headers.basic(credentials)
		)
	},
	passwordRecover (context, model) {
		return context.$http.post(
			`${url}/auth/password/recover`,
			model
		)
	},
	passwordRequest (context, model) {
		return context.$http.post(
			`${url}/auth/password/request`,
			model
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/auth.js